<template>
    <div class="introduce">
        <div class="introduce_center">
            <bannerCenter
                    :box="box"
            ></bannerCenter>
            <div class="introduce_thr">
                <div class="about_thr_left">
                    <div :class="item.isShow ? 'pageTopHide':'pageTopShow'" v-for="(item, index) in troList" :key="index" @click="isShow(item,index)">
                        <div class="xian"></div>
                        {{item.text}}
                    </div>
                </div>
                <div>
                    <div class="about_thr_right" id="text">
                        <div class="about_thr_rightO">平台规模</div>
                        <div class="about_thr_rightT">PLATFORM SCALE</div>
                        <div class="about_thr_right_thr">
                            <div class="about_thr_rightF">
                                <div class="img_fir"></div>
                                <div class="title">100亿+交易量企业</div>
                                <div class="texts">逍遥推手作为全国首家综合生态创业平台，短短两年时间已实现月交易量超百亿的庞大规模。</div>
                            </div>
                            <div class="line"></div>
                            <div class="about_thr_rightF">
                                <div class="img_sec"></div>
                                <div class="title title_margin">全国30万+推手用户</div>
                                <div class="texts texts_margin" style="width: 243px;">公司以“稳”字做出的市场口碑为企业名片，以积极、务实、共创、共赢为合作理念，赢得全国30万+推手用户的信赖。</div>
                            </div>
                            <div class="line"></div>
                            <div class="about_thr_rightF">
                                <div class="img_thi"></div>
                                <div class="title">100万+终端用户</div>
                                <div class="texts">逍遥推手只选择官方产品，以优质产品为导向，为用户提供多元化的非金及金融综合产品。</div>
                            </div>
                        </div>
                    </div>
                    <div class="about_thr_right height" id="text_one">
                        <div class="about_thr_rightO">平台优势</div>
                        <div class="about_thr_rightT">PLATFORM ADVANTAGES</div>
                        <div class="about_thr_right_thr">
                            <div class="about_thr_rightF">
                                <div class="img_A">
                                    <img src="./img/slice1.png" alt="">
                                </div>
                                <div class="title">低门槛,低风险</div>
                                <div class="texts">创业不需要大量启动资金，真正的低门槛，低风险；扁平化保证每个人利益分配公平公正。</div>
                            </div>
                            <div class="line_long"></div>
                            <div class="about_thr_rightF">
                                <div class="img_A img_B">
                                    <img src="./img/slice2.png" alt="">
                                </div>
                                <div class="title">多元化产品经营</div>
                                <div class="texts">一个平台实现多元化产品经营，优化传统模式多平台运行繁琐损作，降低运营成本，满足客户多元化需求，实现交易量叠加。
                                </div>
                            </div>
                            <div class="line_long"></div>
                            <div class="about_thr_rightF">
                                <div class="img_A img_C">
                                    <img src="./img/slice3.png" alt="">
                                </div>
                                <div class="title"></div>
                                <div class="texts"></div>
                            </div>
                            <div class="line_long"></div>
                            <div class="about_thr_rightF">
                                <div class="img_A img_D">
                                    <img src="./img/slice4.png" alt="">
                                </div>
                                <div class="title"></div>
                                <div class="texts"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import bannerCenter from '../../components/bannerCenter'
    export default {
        data(){
            return{
                troList:[
                    {
                        text:'平台规模',
                        isShow:true,
                    },
                    {
                        text:'平台优势',
                        isShow:false,
                    }
                ],
                introduce:true,
                progress:false,
                box:{
                    boxText:'平台介绍',
                    boxTextWe:'平台介绍',
                    boxTextEn:'PLATFORM INTRODUCTION'
                }
            }
        },
        components:{
            bannerCenter
        },
        mounted(){},
        methods:{
            isShow(item,index){
                for (let item in this.troList) {
                    this.troList[item].isShow = false
                }
                this.troList[index].isShow = true;
                if(index == 1){
                    var PageId = document.querySelector("#text_one");
                }else{
                    var PageId = document.querySelector("#text");
                }
                window.scrollTo({
                    top: PageId.offsetTop - 100,
                    behavior: "smooth",
                });
            }
        }
    }
</script>

<style lang="less" scoped>
.introduce{
    width: 100%;
    height: 100%;
    font-size: 13px;
    a{text-decoration:none};
    .introduce_center{
        width: 100%;
        height: calc(100% - 62px);
        top: 62px;
        z-index: -1;
        .introduce_thr{
            width: 100%;
            flex: 1;
            background: #ffffff;
            display: flex;
            .about_thr_left{
                width: 91px;
                background: #ffffff;
                font-size: 10px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #1E1E1E;
                padding: 29px 0 0 202px;
                div:nth-child(1){
                    margin-bottom: 5px;
                    border-bottom: 0.5px solid #EDEDED;
                }
                .pageTopHide{
                    display: flex;
                    font-size: 10px;
                    .xian{
                        width: 2px;
                        height: 15px;
                        background: #3E83FE;
                        border-radius: 1px;
                        margin-right: 9px;
                    }
                }
                .pageTopShow{
                    display: flex;
                    .xian{
                        width: 2px;
                        height: 15px;
                        background: #fff;
                        border-radius: 1px;
                        margin-right: 9px;
                    }
                }
            }
            .about_thr_right{
                font-weight: 400;
                font-size: 17px;
                color: #1E1E1E;
                font-family: Microsoft YaHei;
                width: 585px;
                text-align: center;
                padding: 11px 0 45px;
                .about_thr_rightT{
                    font-size: 11px;
                    font-weight: 300;
                    color: #3D3D3D;
                    margin-bottom: 28px;
                }
                .about_thr_right_thr{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .about_thr_rightF{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin-bottom: 10px;
                        width: 147px;
                        .img_fir{
                            width: 74px;
                            height: 74px;
                            background: url("./img/slice5.png");
                            background-size: 74px 74px;
                        }
                        .img_sec{
                            width: 74px;
                            height: 74px;
                            background: url("./img/slice6.png");
                            background-size: 74px 74px;
                            margin-bottom: 15px;
                            margin-top: 25px;
                        }
                        .img_thi{
                            width: 74px;
                            height: 74px;
                            background: url("./img/slice7.png");
                            background-size: 74px 74px;
                        }
                        .img_A{
                            width: 96px;
                            height: 96px;
                            background: #3E83FE;
                            border-radius: 50%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            img{
                                width: 62px;
                                height: 64px;
                            }
                        }
                        .img_B{
                            margin-top: 10px;
                            img{
                                width: 56px;
                                height: 46px;
                            }
                        }
                        .img_C{
                            margin-top: 10px;
                            img{
                                width: 52px;
                                height: 42px;
                            }
                        }
                        .img_D{
                            margin-top: -5px;
                            img{
                                width: 52px;
                                height: 46px;
                            }
                        }
                        .title{
                            font-size: 15px;
                            font-family: Microsoft YaHei;
                            font-weight: bold;
                            color: #000000;
                            margin: 15px 0 13px;
                        }
                        .texts{
                            font-size: 10px;
                            font-family: Microsoft YaHei;
                            font-weight: 300;
                            color: #000000;
                        }
                        .title_margin{
                            margin-bottom: 0px !important;
                            margin-top: 0;
                        }
                        .texts_margin{
                            margin-top: 10px;
                        }
                    }
                    .line{
                        width: 1px;
                        height: 227px;
                        background: url("./img/xu1.png") no-repeat;
                        background-size: 1px 227px;
                        margin: 0 20px;
                    }
                    .line_long{
                        width: 1px;
                        height: 302px;
                        background: url("./img/xu2.png") no-repeat;
                        background-size: 1px 302px;
                        margin: 0 20px;
                    }
                    .about_thr_progress{
                        width: 518px;
                        height: 725px;
                        /*background: url("") no-repeat;*/
                        background-size: 518px 725px;
                        margin: 0 auto;
                    }
                }

            }
            .height{
                padding-bottom: 48px !important;
            }
        }
    }

}
</style>
